import { render, staticRenderFns } from "./CustomFooter.vue?vue&type=template&id=4e192d49&scoped=true&"
import script from "./CustomFooter.vue?vue&type=script&lang=js&"
export * from "./CustomFooter.vue?vue&type=script&lang=js&"
import style0 from "./CustomFooter.vue?vue&type=style&index=0&id=4e192d49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e192d49",
  null
  
)

export default component.exports